import { MODAL_MUTUAL_FRIENDS_OPT_IN_INITIAL_STEP } from 'Store/mutualFriends/constants';

const mutualFriendsInitialState = {
  contactPickerPermissionGranted: false,
  isLoading: false,
  step: MODAL_MUTUAL_FRIENDS_OPT_IN_INITIAL_STEP,
};

export default mutualFriendsInitialState;
